import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { fetchAccounts } from '@modules-deprecated/app/accounts/query-api'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'

interface UseFetchAccountsOptions {
  enabled?: boolean
}

export const useFetchAccounts = ({ enabled = true }: UseFetchAccountsOptions = {}) => {
  const { organization } = useUserOrganization()
  const { data, isError, isIdle, isLoading } = useQuery(
    [QueryKeys.Accounts, organization?.id],
    () => fetchAccounts(organization?.id || ''),
    {
      enabled: !!organization?.id && enabled,
    },
  )

  const accounts = useMemo(() => data?.accounts || [], [data?.accounts])

  return {
    accounts,
    meta: data?.meta,
    isError,
    isIdle,
    isLoading,
  }
}
